import { render, staticRenderFns } from "./ReactionsPicker.vue?vue&type=template&id=0bce4b8c&scoped=true&lang=pug"
import script from "./ReactionsPicker.vue?vue&type=script&lang=js"
export * from "./ReactionsPicker.vue?vue&type=script&lang=js"
import style0 from "./ReactionsPicker.vue?vue&type=style&index=0&id=0bce4b8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce4b8c",
  null
  
)

export default component.exports